// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tx","itemWrapper":"ty rQ","itemStyle":"tz rR"};